/* oxlint-disable @typescript-eslint/no-explicit-any */
import { HttpClient, HttpContext } from "@angular/common/http";
import { Injectable, inject, OnDestroy } from "@angular/core";
import { Observable, of, Subscription } from "rxjs";
import { catchError } from "rxjs/operators";

import { Menu } from "@hermes/api-model-menu";
import { Settings } from "@hermes/core-app-core";
import { SKIP_404_INTERCEPTOR } from "@hermes/utils-generic-constants";

@Injectable()
export class MenuService implements OnDestroy {
    private http = inject(HttpClient);
    private settings = inject(Settings);

    private subscription = new Subscription();

    public ngOnDestroy(): void {
        this.subscription.unsubscribe();
    }

    /**
     * Retrieves categories from CMS.
     */
    public fetchMenuDatas(): Observable<Menu> {
        return this.http
            .get<Menu>(`${this.settings.apiUrl}/menu`, {
                context: new HttpContext().set(SKIP_404_INTERCEPTOR, true),
            })
            .pipe(
                catchError(() => {
                    const menu: Menu = {
                        mainMenu: undefined,
                        aboutMenu: undefined,
                    };
                    return of(menu);
                }),
            );
    }
}
